
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45866","data-name":"Group 45866","transform":"translate(-338 -106)"}},[_c('g',{attrs:{"id":"Ellipse_879","data-name":"Ellipse 879","transform":"translate(338 106)","fill":"#fff","stroke":"#d6ddea","stroke-width":"1"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","stroke":"none"}}),_c('circle',{attrs:{"cx":"7","cy":"7","r":"6.5","fill":"none"}})]),_c('g',{attrs:{"id":"Group_45773","data-name":"Group 45773","transform":"translate(-45 -205)","fill":"none","stroke":"#727992","stroke-linecap":"round","stroke-width":"1.5"}},[_c('line',{attrs:{"id":"Line_1461","data-name":"Line 1461","x2":"7.777","transform":"rotate(45 -186.915 625.077)"}}),_c('line',{attrs:{"id":"Line_1462","data-name":"Line 1462","x2":"7.777","transform":"rotate(135 131.085 238.966)"}})])])])
          )
        }
      }
    